import { Component, OnInit, Input, Output, EventEmitter  } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

import { MY_DATE_FORMATS, FilterStructure, GeneralFilterComponent } from '../../../models/generic-filter';

@Component({
  selector: 'app-gestione-utenti-filter',
  templateUrl: './gestione-utenti-filter.component.html',
  styleUrls: ['./gestione-utenti-filter.component.css']
})
export class GestioneUtentiFilterComponent extends GeneralFilterComponent implements OnInit {
    @Output() updateFilterEmitter = new EventEmitter();

    constructor() {
        super();
    }

    ngOnInit() {
        super.setResetContext(false);
        this.filterFormGroup = new FormGroup({
            codiceFiscaleControl: new FormControl({ value: "", disabled: false, }),
            nomeCompletoControl: new FormControl({ value: "", disabled: false, }),
        });
        let filterFormGroup = this.filterFormGroup.getRawValue();
        for(let key in filterFormGroup){
            if(filterFormGroup.hasOwnProperty(key)){
                let val = filterFormGroup[key];
                this.filterFormGroup.get(key).valueChanges.subscribe(() => {
                    if(!super.getResetContext())
                        this.updateFilters();
                });
                //console.log("filterFormGroup", key, val);
            }
        }
        this.resetFilters();
    }

    ngOnChanges(changes: any){
      console.log('CHANGE ANAGRAFICA-FILTER', changes);
      if(changes.filter){
              console.log('CHANGE ANAGRAFICA-FILTER FILTER', changes);
              this.updateFilters();
      }
	}

    generateFilterMap(){
        let filterStructureLocal: any = null;
        super.resetFilterMap();
        let codiceFiscaleValue = "";
        let nomeCompletoValue = "";

        if(this.filterFormGroup){
            codiceFiscaleValue = this.filterFormGroup.get('codiceFiscaleControl').value;
            nomeCompletoValue = this.filterFormGroup.get('nomeCompletoControl').value;
        }

        filterStructureLocal = { "name": "codice_fiscale", "value": codiceFiscaleValue, "type": "string", "op": "=" };
        super.setFilterStructure("codice_fiscale", filterStructureLocal);

        filterStructureLocal = { "name": "nomeCompleto", "value": nomeCompletoValue, "type": "string", "op": "=" };
        super.setFilterStructure("nomeCompleto", filterStructureLocal);
    }

    clearField(nameField: string, updateFilters: boolean = true){
        //console.log('clearField', nameField, updateFilters);
        switch(nameField){
            case "codiceFiscaleControl":{
                this.filterFormGroup.get("codiceFiscaleControl").setValue("");
                break;
            }
            case "nomeCompletoControl":{
                this.filterFormGroup.get("nomeCompletoControl").setValue("");
                break;
            }
        }
        if(updateFilters){
            this.updateFilters();
        }
    }


    updateFilters(){
        this.generateFilterMap();
        let filterMapLocal = super.getFilterMap();
        let eventObject = {
            type: 'updateFiltersMap',
            data: filterMapLocal,
        };
        //console.log('UPDATE FILTERMAPLOCAL', eventObject);
        this.updateFilterEmitter.emit(eventObject);
    }

    resetFilters(){
        let filterMapLocal = super.getFilterMap();
        //console.log('RESET FILTER', filterMapLocal);
        super.setResetContext(true);
        let filterFormGroup = this.filterFormGroup.getRawValue();
        for(let key in filterFormGroup){
            if(filterFormGroup.hasOwnProperty(key)){
                this.clearField(key, false);
            }
        }
        this.updateFilters();
        super.setResetContext(false);
        filterMapLocal = super.getFilterMap();
        //console.log('RESET FILTER', filterMapLocal);
        return filterMapLocal;
    }
}
